var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Generic',{attrs:{"item":_vm.item},scopedSlots:_vm._u([{key:"indicator",fn:function(){return [(_vm.status)?_c('div',{staticClass:"status",class:_vm.status},[_vm._v(" "+_vm._s(_vm.status)+" ")]):_vm._e()]},proxy:true}])})}
var staticRenderFns = []

export { render, staticRenderFns }